import {Injectable} from "@angular/core";
import {throwError} from "rxjs/internal/observable/throwError";
import { HttpClient } from "@angular/common/http";
import {catchError} from "rxjs/internal/operators/catchError";
import {ZendeskTicket} from "../models/ZendeskTicket";

@Injectable({
    providedIn: 'root'
})
export class ZendeskService {
    constructor(private _http: HttpClient) {

    }

    public createTicket(ticket: ZendeskTicket) {
        return this._http.post<boolean>(`api/Zendesk/CreateTicket`, ticket)
            .pipe(catchError((this.handleError)))
        
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }

}
